import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { UtilsService } from 'src/app/core/services/utils.service';

@Injectable({
  providedIn: 'root'
})
export class TransactionRevisionExternalService  extends BaseProvider {

  term: any = '';
  list: any = [];
  constructor(

    public globals: GlobalsService,
    public http: HttpClient,	
    public ls: LsHelperService,
    public authService: AuthService,
    public utilsService: UtilsService 		

  ) {

    super();

    this.baseUrl = "revisionExternal";	

  }

  getRevisionStatusLog(params){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + 
                  '/get/userProcess/' + params.userProcessId + 
                  '/requirement/' + params.requirementId;			

		    this.http
		    .get(this.url)
		    .subscribe(
		        (data: any) => {
		        	resolve(data.Data);
		        },
		        err => {reject(err)}
		    );
		});		
	} 	

  createRevisionStatusLog(params){
    return new Promise( (resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + 
                 '/userProcess/' + params.userProcessId + 
                 '/requirement/' + params.requirementId;

        this.http
        .post(
          this.url, 
          params
        )
        .subscribe(
            (data: any) => {
                resolve(data);
            },
            err => {reject(err)}
        );
    });     		
  }
  remediateRevisionStatusLog(params){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + 
                 '/remediate/userProcess/' + params.userProcessId + 
                 '/requirement/' + params.requirementId;

		    this.http
		    .put(this.url, params)
		    .subscribe(
		        (data: any) => {
		        	resolve(data);
		        },
		        err => {reject(err)}
		    );
		});			
	}	
  
  deleteRevisionStatusLog(params){
		return new Promise( (resolve, reject) => {
		  this.url = this.globals.dataUrl + this.baseUrl + 
                  '/delete/userProcess/' + params.userProcessId + 
                  '/requirement/' + params.requirementId;			
		    this.http
		    .delete(
		      this.url
		    )
		    .subscribe(
		        (data: any) => {
		            resolve(data);
		        },
		        err => {reject(err)}
		    );
		});      
	} 

}
